/**
 * \u73bb\u7483\u5b9d\u77f3\u591a\u89d2\u5f62\u5de5\u5177 \u2014\u2014 \u6e90\u81ea design/art/02-board-mock.html \u7684 poly/circle/\u8f6e\u5ed3\u51fd\u6570\u3002
 */

export interface Pt { x: number; y: number }

/** \u6b63\u591a\u8fb9\u5f62\u9876\u70b9 */
export function poly(cx: number, cy: number, r: number, n: number, rot = 0): Pt[] {
  const pts: Pt[] = [];
  for (let i = 0; i < n; i++) {
    const a = rot + (i * Math.PI * 2) / n - Math.PI / 2;
    pts.push({ x: cx + Math.cos(a) * r, y: cy + Math.sin(a) * r });
  }
  return pts;
}

/** \u692d\u5706\u8f6e\u5ed3\u62df\u5408\uff08\u4fdd\u7559\u63a5\u53e3\uff0c\u5f53\u524d\u516d\u8272\u672a\u7528\uff09 */
export function ellipsePts(cx: number, cy: number, rx: number, ry: number, seg = 48): Pt[] {
  const pts: Pt[] = [];
  for (let i = 0; i < seg; i++) {
    const a = (i * Math.PI * 2) / seg;
    pts.push({ x: cx + Math.cos(a) * rx, y: cy + Math.sin(a) * ry });
  }
  return pts;
}

/** \u5148\u5929\u5f62\u4e0e shape \u5b57\u7b26\u4e32\u7684\u6620\u5c04\uff08\u4fdd\u6301\u4e0e\u539f\u578b\u4e00\u81f4\uff09 */
export function silhouette(shape: string, cx: number, cy: number, r: number): Pt[] {
  switch (shape) {
    case 'hex': return poly(cx, cy, r, 6, Math.PI / 6);
    case 'oct': return poly(cx, cy, r, 8, Math.PI / 8);
    case 'ellipse': return ellipsePts(cx, cy, r * 0.82, r);
    default: return ellipsePts(cx, cy, r, r);
  }
}

/** \u8def\u5f84\u5e8f\u5217\u5316\uff08\u7528\u4e8e\u586b\u5145/\u63cf\u8fb9\uff09 */
export function pathOf(pts: Pt[], close = true): string {
  if (pts.length === 0) return '';
  let d = `M ${pts[0].x.toFixed(2)} ${pts[0].y.toFixed(2)}`;
  for (let i = 1; i < pts.length; i++) d += ` L ${pts[i].x.toFixed(2)} ${pts[i].y.toFixed(2)}`;
  return close ? d + ' Z' : d;
}

/** \u7f29\u653e\u9876\u70b9\u96c6 */
export function scalePts(pts: Pt[], cx: number, cy: number, k: number): Pt[] {
  return pts.map((p) => ({ x: cx + (p.x - cx) * k, y: cy + (p.y - cy) * k }));
}
